// GENERATED FILE - DO NOT MODIFY
export enum BonusGroup {
    Income = "R",
}

export let nameof = "BonusGroup";
